import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import Router from './routes/router';
import reportWebVitals from './reportWebVitals';
import LFEStore from './contexts/SessionProvider';
import { Provider } from 'react-redux';
import LysepThemeProvider from './contexts/ThemeProvider';
import { CookiesProvider } from 'react-cookie';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { UserProfileProvider } from './contexts/UserProfileContext';
import axios from 'axios'

axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CookiesProvider>
    <Provider store={LFEStore}>
      <AuthProvider>
        <PermissionProvider>
          <UserProfileProvider>
            <Router />
          </UserProfileProvider>
        </PermissionProvider>
      </AuthProvider>
    </Provider>
  </CookiesProvider>
);

